<owl-carousel-o [options]="customOptions">


    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <img  src="assets/banners/SML-{{this.lang}}.jpg"/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->

    <ng-container *ngFor="let banner of slider?.banners">
        <ng-template carouselSlide>
            <div class="row no-gutters">
                <div class="col-12">
                    <!--                    <img src="assets/banners/WEB_FIFA-2022_{{this.lang}}.jpg"/>-->
                    <a href="{{banner.custom_attributes[0]?.attribute_value}}">
                        <img src="{{env.baseAPI2}}/files/download/banner-image/desk_image/{{banner.custom_attributes[1].attribute_value}}/{{banner.id}}"/>
                    </a>
                    <!--                    <img src="assets/banners/WEB_FIFA-2022_{{this.lang}}.jpg"/>-->

                </div>
            </div>
        </ng-template>
    </ng-container>
    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <img src="assets/banners/WEB_FIFA-2022_{{this.lang}}.jpg"/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->


    <!--    &lt;!&ndash;    <ng-template carouselSlide>&ndash;&gt;-->
    <!--    &lt;!&ndash;        <div class="row no-gutters">&ndash;&gt;-->
    <!--    &lt;!&ndash;            <div class="col-12">&ndash;&gt;-->
    <!--    &lt;!&ndash;                <img  src="assets/banners/sale_online_15_{{this.lang}}.jpg"/>&ndash;&gt;-->
    <!--    &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;    </ng-template>&ndash;&gt;-->


    <!--    &lt;!&ndash;    <ng-template carouselSlide>&ndash;&gt;-->
    <!--    &lt;!&ndash;        <div class="row no-gutters">&ndash;&gt;-->
    <!--    &lt;!&ndash;            <div class="col-12">&ndash;&gt;-->
    <!--    &lt;!&ndash;                <img  src="assets/banners/mob_banner_{{this.lang}}.jpeg"/>&ndash;&gt;-->
    <!--    &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;    </ng-template>&ndash;&gt;-->


    <!--    &lt;!&ndash;    <ng-template carouselSlide>&ndash;&gt;-->
    <!--    &lt;!&ndash;        <div class="row no-gutters">&ndash;&gt;-->
    <!--    &lt;!&ndash;            <div class="col-12">&ndash;&gt;-->
    <!--    &lt;!&ndash;                <img  src="assets/banners/sale_13_{{this.lang}}.jpg"/>&ndash;&gt;-->
    <!--    &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;    </ng-template>&ndash;&gt;-->

    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <a href="https://alarabiya.com.kw/360-tour" target="_blank"><img-->
    <!--                        src="assets/banners/SMALL_{{this.lang}}-360.jpg" style="cursor: pointer;"/></a>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->


    <!--    &lt;!&ndash;    <ng-template carouselSlide>&ndash;&gt;-->
    <!--    &lt;!&ndash;        <div class="row no-gutters">&ndash;&gt;-->
    <!--    &lt;!&ndash;            <div class="col-12">&ndash;&gt;-->
    <!--    &lt;!&ndash;                <img  src="assets/banners/12_{{this.lang}}.jpg" style="cursor: pointer;" />&ndash;&gt;-->
    <!--    &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    &lt;!&ndash;    </ng-template>&ndash;&gt;-->


    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <img src="assets/banners/laser_{{this.lang}}.jpg"/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->


    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <img [routerLink]="'categories/808'" src="assets/banners/ALFANAR.jpg"/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->

    <!--    <ng-template carouselSlide>-->
    <!--        <div class="row no-gutters">-->
    <!--            <div class="col-12">-->
    <!--                <img [routerLink]="'../../search/opple'" src="assets/banners/Opple.jpg"/>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-template>-->


</owl-carousel-o>
